<template>
    <div class="gray-back" style="padding:.2rem 0 8rem 0 ; height:auto !important">


            <van-divider>{{saiqu.name}} {{start.title}}</van-divider>
      <van-cell-group>
                <van-cell :key="index" v-for="(row,index) in list" :title="'#'+(index+1)+' '+row.mingcheng" @click="selectShow(row)"  is-link=""> 
                    <template slot="label">
                      <span class="font-size0 van-color-text-assist"> {{row.subject_name}}</span>
                      <div v-if="row.jianlu_status==6 && row.jianlu_note" class="jianlu-note-line">{{ row.jianlu_note }}</div>
                    </template>
                    <template>
                    <span style="color:#999" v-if="row.jianlu_status==0" >待检录</span> 
                    <!-- <span style="color:#1989fa"  v-else-if="row.jianlu_status==1" >检录1</span> 
                    <span style="color:#1989fa"  v-else-if="row.jianlu_status==2">检录2</span> 
                    <span style="color:#1989fa"  v-else-if="row.jianlu_status==3">检录3</span>  -->
                    <span style="color:#1989fa"  v-else-if="row.jianlu_status==4">已签到</span> 
                    <span style="color:#32ae57"  v-else-if="row.jianlu_status==5">检录完成</span> 
                    <span style="color:#f00"  v-else-if="row.jianlu_status==6">待整改</span> 
                    <span style="color:#000"  v-else-if="row.jianlu_status==7">比赛完成</span> 
                    <span style="color:#c39004"  v-else-if="row.jianlu_status==8">弃权</span> 
                    <span style="color:#f00"  v-else-if="row.jianlu_status==9">超时未到</span>
                  </template>
                </van-cell>

      </van-cell-group>

      <van-action-sheet v-model="optionsShow" :actions="actions" @select="onSelect" />

      <van-dialog
        v-model="jianluNoteShow"
        title="整改问题说明"
        show-cancel-button
        confirm-button-text="提交"
        :before-close="onJianluNoteBeforeClose"
      >
        <div class="jianlu-note-dialog-body">
          <van-field
            v-model="jianluNoteInput"
            type="textarea"
            rows="4"
            maxlength="500"
            placeholder="请输入问题内容"
            show-word-limit
          />
        </div>
      </van-dialog>

  </div>
</template>

<script>
import { Toast, ActionSheet, Dialog, Field } from "vant";
export default {
  name: "StartList",
  data: function () {
    return {
      optionsShow: false,
      selectId: 0,
      jianluNoteShow: false,
      jianluNoteInput: "",
      actions: [
        { name: '待检录', status: 0 },
        // { name: '检录1', status: 1 },
        // { name: '检录2', status: 2 },
        // { name: '检录3', status: 3 },
        { name: '已签到', subname: '', status: 4 },
        { name: '检录完成', subname: '', status: 5 },
        { name: '播报入场', subname: '', kind: 'broadcast' },
        { name: '待整改', subname: '', status: 6 },
        { name: '比赛完成', subname: '', status: 7 },
        { name: '弃权', subname: '', status: 8 },
        { name: '超时未到', subname: '', status: 9 },
      ],
        start: { 
        },
        saiqu:{},
        list: [], 
    }
  },
  components: {
    ActionSheet,
    Dialog,
    Field,
  },
  filters: {},
  mounted() {
    let that = this;
    document.title="检录信息"
    that.fetch()
    // 换成轮询
    that.timer = setInterval(function () {
      that.fetch()
    }, 2000)
  },
  destroyed() {
    // 销毁监听
    // this.socket.close()
    clearInterval(this.timer)
  },
  methods: {
    selectShow(row){
      this.optionsShow=true;
      this.selectId = row.id
    },
    onSelect(action) {
      if (action && action.kind === 'broadcast') {
        this.optionsShow = false
        const row = this.list.find((r) => r.id === this.selectId)
        if (!row || !(String(row.danwei || '').trim())) {
          Toast('单位名称为空，无法播报')
          return
        }
        this.$api.post(
          '/api/dscore/jianluBroadcastEntrance',
          { id: this.selectId },
          () => {
            Toast.success('已推送入场播报')
          },
          (res) => {
            Toast(res.msg || '播报失败')
          }
        )
        return
      }
      const status = action && action.status
      if (status === undefined) {
        return
      }
      if (status === 6) {
        this.optionsShow = false
        const row = this.list.find((r) => r.id === this.selectId)
        this.jianluNoteInput =
          row && row.jianlu_note ? String(row.jianlu_note) : ""
        this.jianluNoteShow = true
        return
      }
      this.submitSetJianlu(status, "")
    },
    onJianluNoteBeforeClose(action, done) {
      if (action === "confirm") {
        const note = (this.jianluNoteInput || "").trim()
        if (!note) {
          Toast("请填写问题内容")
          done(false)
          return
        }
        const that = this
        that.$api.post(
          "/api/dscore/setjianlu",
          {
            status: 6,
            id: that.selectId,
            jianlu_note: note,
          },
          () => {
            that.jianluNoteInput = ""
            done()
            that.fetch()
          },
          (res) => {
            Toast(res.msg)
            done(false)
          }
        )
      } else {
        this.jianluNoteInput = ""
        done()
      }
    },
    submitSetJianlu(status, jianlu_note) {
      const that = this
      that.$api.post(
        "/api/dscore/setjianlu",
        {
          status,
          id: that.selectId,
          jianlu_note: jianlu_note || "",
        },
        () => {
          that.optionsShow = false
          that.fetch()
        },
        (res) => {
          Toast(res.msg)
        }
      )
    },
    fetch() {
      let that = this;
      that.$api.post('/api/dscore/scoreStartJianluSubjectList', { 
        start_id: that.$route.query.start_id,
      }, (res) => {
        that.list = res.data.list;
        that.saiqu = res.data.saiqu;
        that.start = res.data.start;
      }, (res) => {
        Toast(res.msg) 
      })
    },
  }
}
</script>

<style scoped>
.jianlu-note-line {
  margin-top: 4px;
  font-size: 12px;
  color: #ee0a24;
  line-height: 1.4;
  word-break: break-all;
}
.jianlu-note-dialog-body {
  padding: 12px 16px 8px;
}
</style>



// WEBPACK FOOTER //
// StartList.vue?86a8424c